var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visaPageImage)?_c('div',{staticClass:"passPhoto"},[_c('p',[_vm._v("签证图例")]),_c('div',{staticClass:"example"},[_c('img',{attrs:{"src":_vm.visaPageImage,"alt":"visa"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }